import { CostsControl } from './CostsControl';
import { CountrySelector } from './CountrySelector';
import { ProjectCurrency } from './ProjectCurrency';
import { Total } from './Total';

import { StepComponentProps } from '../types';
import { Column } from 'components/Blocks';

export function Costs({ state, dispatch }: StepComponentProps) {
  return (
    <Column gap="8">
      <ProjectCurrency state={state} dispatch={dispatch} />

      {!!state.currency && (
        <>
          <CountrySelector countries={state.countries} dispatch={dispatch} />

          <CostsControl state={state} dispatch={dispatch} />

          <Total state={state} />
        </>
      )}
    </Column>
  );
}
